"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
const checkmark_svg_1 = __importDefault(require("../../assets/icons/checkmark.svg"));
function FeaturesTable({ t }) {
    const features = t(i18n_1.Strings.userOnboarding.subsSheet.features, {
        returnObjects: true,
    });
    const featureEntries = Object.entries(features);
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'FeaturesTable_Container', children: (0, jsx_runtime_1.jsxs)(Table, { "data-e2e": 'FeaturesTable_Table', children: [(0, jsx_runtime_1.jsx)("thead", { "data-e2e": 'FeaturesTable_thead', children: (0, jsx_runtime_1.jsxs)(HeaderRow, { "data-e2e": 'FeaturesTable_HeaderRow', children: [(0, jsx_runtime_1.jsx)(Header, { "data-e2e": 'FeaturesTable_Header' }), (0, jsx_runtime_1.jsx)(Header, { "data-e2e": 'FeaturesTable_Header', children: t(i18n_1.Strings.userOnboarding.subsSheet.free) }), (0, jsx_runtime_1.jsx)(Header, { "data-e2e": 'FeaturesTable_Header', children: t(i18n_1.Strings.userOnboarding.subsSheet.subscription) })] }) }), (0, jsx_runtime_1.jsx)("tbody", { "data-e2e": 'FeaturesTable_tbody', children: featureEntries.map(([key, value]) => ((0, jsx_runtime_1.jsxs)(Row, { "data-e2e": 'FeaturesTable_Row', children: [(0, jsx_runtime_1.jsx)(Column, { "data-e2e": 'FeaturesTable_Column', children: value }), key === 'skeletal' ? ((0, jsx_runtime_1.jsx)(Data, { "data-e2e": 'FeaturesTable_Data', children: (0, jsx_runtime_1.jsx)(StyledCheckmark, { "data-e2e": 'FeaturesTable_StyledCheckmark' }) })) : ((0, jsx_runtime_1.jsx)(Data, { "data-e2e": 'FeaturesTable_Data' })), (0, jsx_runtime_1.jsx)(Data, { "data-e2e": 'FeaturesTable_Data', children: (0, jsx_runtime_1.jsx)(StyledCheckmark, { "data-e2e": 'FeaturesTable_StyledCheckmark' }) })] }, key))) })] }) }));
}
exports.FeaturesTable = FeaturesTable;
exports.default = FeaturesTable;
const Container = styled_components_1.default.div `
  margin: 1em auto;
  width: 100%;
`;
const Table = styled_components_1.default.table `
  border-collapse: collapse;
  margin: 0 auto;
  width: 310px;
`;
const Header = styled_components_1.default.th `
  padding-left: 2em;
  font-weight: normal;
  text-align: center;
`;
const HeaderRow = styled_components_1.default.tr `
  height: 30px;
  border-bottom: 1px solid #ffffff;
  color: white;
  font-size: 14px;
  text-align: right;
`;
const Row = styled_components_1.default.tr `
  height: 62px;
  border-bottom: 1px solid #ffffff;
  color: white;
  font-size: 14px;
`;
const Column = styled_components_1.default.td `
  padding: 1em 0.25em;
  width: 140px;
`;
const Data = styled_components_1.default.td `
  padding-left: 2em;
  text-align: center;
`;
const StyledCheckmark = (0, styled_components_1.default)(checkmark_svg_1.default) `
  width: 18px;
  height: 14px;
  max-width: 18px !important;
  max-height: 14px !important;
`;
